import React from 'react';
import DataTable from 'react-data-table-component';
import '../../../libs/css/dataTable.css';
import Nulls from '../Nulls';
import { format } from 'date-fns';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';


function SubUsersTable(props) {
    const { dataList, dataTotal, isLoading, countPerPage, setPage, editSubUser, deleteSubUser } = props;

    const columns = [
        {
            name: 'Sn',
            selector: (row, index) => index + 1,
            width: '70px',
        },
        {
            name: 'Name',
            selector: row => row.name ? row.name : <Nulls />,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email ? row.email : <Nulls />,
            sortable: true,
        },
        {
            name: 'Status',
            cell: row => (
                row.status === 1
                ? <span style={{ color:'#027937', fontWeight:'600' }}>Active</span>
                : <span style={{ color:'red', fontWeight:'600' }}>Deleted</span>
            ),
        },
        {
            name: 'Date Created',
            selector: row => row.created_at ? format(new Date(row.created_at), 'MMM d, yyyy h:mma') : <Nulls />,
        },
        {
            name: 'Action',
            cell: row => {
                const isDeleted = row.status !== 1;
                return (
                    <>
                        <i className='fa fa-edit' onClick={() => !isDeleted && editSubUser(row)} title={isDeleted ? "Can't edit a deleted sub user" : "Edit"}
                            style={{ fontSize:'22px', color: isDeleted ? '#ccc' : '#069', cursor: isDeleted ? 'not-allowed' : 'pointer' }}></i> &nbsp;&nbsp;

                        <i className='fa fa-trash' onClick={() => deleteSubUser(row)} title="Delete" style={{ fontSize:'22px', color:'red', cursor:'pointer' }}></i>
                    </>
                );
            },
        }
    ];

    return (
        <div className="App">
            {
                isLoading ?
                <LoadingSpinner />
                :
                <>
                    <DataTable
                        className="services_datatable users"
                        title=""
                        columns={columns}
                        data={dataList}
                        highlightOnHover
                        pagination
                        paginationPerPage={countPerPage}
                        onChangePage={page => setPage(page)}
                        noDataComponent={<div className='mt-20 mb-20'>No sub users have been created yet</div>}
                    />
                </>
            }
        </div>
    );
}

export default SubUsersTable;
